import cogoToast from "cogo-toast";
import SVG from "react-inlinesvg";
import React, { useEffect, useRef, useState } from "react";
import { Card, CardHeader, CardHeaderToolbar } from "../../../../../_metronic/_partials/controls";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";
import { formatAmount, formatDate, formatStatus } from "../../../../util/Helpers";
import { FilterGroup } from "../../../Common/components/FilterGroup";
import ViewSafeLockModal from "../../../UserManagement/pages/selected-user/view-user/user-pages/safe-locks/modal/ViewSafeLockModal";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useDownloadLiquidationReportMutation } from "../../../../../redux/apiSlice";


const SafeLockLiquidations = () => {
    const tableRefLiquidations = useRef(null);
    /* Safe Lock Modal State Management */
    const [safeLockedModal, setsafeLockedModal] = useState({ showViewSafeLockModal: false, details: null });
    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setsafeLockedModal({ ...safeLockedModal, [modal]: !safeLockedModal[modal] })
    }
    /* View liquidation Details */
    const viewSafeLockDetails = details => {
        setsafeLockedModal({ ...safeLockedModal, showViewSafeLockModal: true, details });
    }


    const renderEmail = (emailAddr) => {
        const truncatedEmail = emailAddr?.slice(0, 6) + "...";

        const handleCopy = () => {
            navigator.clipboard.writeText(emailAddr);
            cogoToast.success("Email copied to clipboard!");
        };

        return (
            <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>
                <span title={emailAddr} style={{ cursor: "pointer" }}>
                    {truncatedEmail}
                </span>
                <span
                    onClick={handleCopy}
                    title="Copy Email"
                    style={{
                        cursor: "pointer",
                        color: "green",
                        fontSize: "12px",
                        fontWeight: "bold",
                    }}
                >
                    📋
                </span>
            </div>
        );
    };

    const actionButtonsafe = row => {

        return <span style={{ whiteSpace: "nowrap" }}>
            <button
                className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
                onClick={_ => viewSafeLockDetails(row)}
            >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                    <SVG
                        title="View safelock"
                        src={toAbsoluteUrl("/media/svg/icons/General/Eye-2.svg")}
                    />
                </span>
            </button>
        </span>
    }

    const [
        downloadLiquidationReport,
        {
            isLoading: isLoadingReport,
            isSuccess: isReportGenerating,
            error: errorReport,
        }
    ] = useDownloadLiquidationReportMutation()

    useEffect(() => {
        if (errorReport) {
            cogoToast.error(errorReport.data);
        }
    }, [errorReport])

    useEffect(() => {
        if (isReportGenerating) {
            cogoToast.success(`Liquidation export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isReportGenerating])

    return (
        <div className="py-4 px-6 flex">
            <FilterGroup defaultFilters={{ endDate: new Date().toISOString().split('T')[0] }}>
                <FilterGroup.DateRange className="mb-4" />

                <div className="d-flex">
                    <div className="mb-4 mr-4">
                        <FilterGroup.Filter name="planId" label="Plan Type">
                            <FilterGroup.Option value="4f2a4bd9-2a08-46d5-85b3-589e414c4754">12 Months Plan (Naira)</FilterGroup.Option>
                            <FilterGroup.Option value="ae02016a-0190-4e4d-9eea-cdec5071680b">12 Months Plan (Dollars)</FilterGroup.Option>
                            <FilterGroup.Option value="2504faa3-a5d0-4646-8834-5324816c1d4f">9 Months Plan (Naira)</FilterGroup.Option>
                            <FilterGroup.Option value="4989e0cc-60e2-40e5-85b1-69b5d764b0d4">9 Months Plan (Dollar)</FilterGroup.Option>
                            <FilterGroup.Option value="0d3313a4-7f84-4c5c-b8a5-b5722db28755">6 Months Plan (Naira)</FilterGroup.Option>
                            <FilterGroup.Option value="2fa52a85-cd23-405f-b12f-f37468726947">6 Months Plan (Dollar)</FilterGroup.Option>
                            <FilterGroup.Option value="857d9a75-30c4-4ed5-a019-83aca75cc6eb">3 Months Plan (Naira)</FilterGroup.Option>
                            <FilterGroup.Option value="4e05babc-0b27-4e9d-8361-c1527c5e32e8">3 Months Plan (Dollar)</FilterGroup.Option>
                        </FilterGroup.Filter>
                    </div>
                </div>

                <FilterGroup.Content>
                    {({ filters }) => (
                        <Card>
                            <CardHeader title="Liquidation List">
                                <CardHeaderToolbar>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={isLoadingReport}
                                        onClick={() => downloadLiquidationReport({
                                            startDate: filters?.startDate || "",
                                            endDate: filters?.endDate || "",
                                            status: filters?.status || "",
                                            format: "csv",
                                        })}
                                    >
                                        Export CSV
                                    </button>
                                </CardHeaderToolbar>

                            </CardHeader>

                            <DynamicSimpleTable
                                queryParams={
                                    `&startDate=${filters?.startDate || ""}` +
                                    `&endDate=${filters?.endDate || ""}` +
                                    `&planId=${filters?.planId || ""}` +
                                    `&status=${filters?.status || ""}`
                                }
                                searchBox={false}
                                source={{ url: `/safe-lock/liquidations` }}
                                columns={[
                                    { title: "Tenure", key: "tenor" },
                                    { title: "Tenure Left", key: "tenorleftover" },
                                    { title: "Customer Name", key: "customerName" },

                                    {
                                        title: "Email",
                                        key: "email",
                                        format: (row) => renderEmail(row.emailAddr),
                                    },
                                    { title: "Transaction Reference", format: (row) => (row.safelockDeposits[0].tranRef) },
                                    { title: "Maturity Date", format: (row) => formatDate(row.safelockDeposits[0].maturityDate) },
                                    { title: "Amount Locked", format: (row) => formatAmount(row.currency, row.safelockDeposits[0].deposit) },
                                    { title: "Rate%", key: "rate" },
                                    { title: "Interest Earned", format: (row) => formatAmount(row.currency, row.safelockDeposits[0].interestEarned) },
                                    { title: "Payback Amount", format: (row) => formatAmount(row.currency, (row.safelockDeposits[0].deposit) + ((row.currency, row.safelockDeposits[0].interestEarned))) },
                                    { title: "Date Created", format: (row) => formatDate(row.safelockDeposits[0].createdAt) },
                                    { title: "Status", format: (row) => formatStatus(row.safelockDeposits[0].paymentStatus) },
                                    { title: "", format: actionButtonsafe }

                                ]}
                                ref={tableRefLiquidations}
                                refreshIcon={true}
                            />
                        </Card>
                    )}
                </FilterGroup.Content>
                <ViewSafeLockModal {...safeLockedModal} onHide={toggleModal("showViewSafeLockModal")} />
            </FilterGroup>
        </div>

    );

};


export default SafeLockLiquidations;
